import {
  LevelList,
  availableTimeList,
  avaliationFisic,
  frequencyList,
  genrerList,
  objectiveList,
} from './constants';

type Props = {
  studentLevelLabel: string;
  frequencyLabel: string;
  genderLabel: string;
  availableTimeLabel: string;
  physicalEvaluationLabel: string;
  objectiveLabel: string;
};

export const getProfileCode = ({
  studentLevelLabel,
  frequencyLabel,
  genderLabel,
  availableTimeLabel,
  physicalEvaluationLabel,
  objectiveLabel,
}: Props): string => {
  const studentLevel = LevelList.filter((item) => {
    return item.code === studentLevelLabel;
  });

  const frqcode = frequencyList.filter((item) => {
    return item.code === frequencyLabel;
  });

  const gnrCodes = genrerList.filter((item) => {
    return item.value === genderLabel;
  });

  const availableTime = availableTimeList.filter((item) => {
    return item.code === availableTimeLabel;
  });

  const fisicalAvCode = avaliationFisic.filter((item) => {
    return item.label === physicalEvaluationLabel;
  });

  const objectiveCodes = objectiveList.filter((item) => {
    return item.code === objectiveLabel;
  });

  let profilecode = '';
  if (gnrCodes.length > 0) {
    profilecode += `${gnrCodes[0].code}-`;
  }
  if (studentLevel.length > 0) {
    profilecode += `${studentLevel[0].code}-`;
  }
  if (fisicalAvCode.length > 0) {
    profilecode += `${fisicalAvCode[0].code}-`;
  }
  if (objectiveCodes.length > 0) {
    profilecode += `${objectiveCodes[0].code}-`;
  }
  if (frqcode.length > 0) {
    profilecode += `${frqcode[0].code}-`;
  }
  if (availableTime.length > 0) {
    profilecode += `${availableTime[0].code}`;
  }

  return profilecode;
};
